import { IPagination, ITripsState } from '../states';

export const initialTripsState: ITripsState = {
  value: [],
  isFetchingTrips: true,
  pagination: {} as IPagination,
  activeTicketsByExpedition: {},
};
